import showAlertErrorHandler from './show-alert-error-handler'
import Vue from 'vue'
import { i18n } from '../plugins/vue-i18n'
import type { InvoiceSummary } from '../types/invoice-summary'
import type { InvoiceDocument } from '../types/invoice-document'

export default {
  props: {
    invoice: {
      type: Object,
      required: true
    }
  },

  methods: {
    isInvoiceDocumentAvailable (invoice: InvoiceSummary, role: string, fileType: string): Boolean {
      const document = this.getInvoiceDocument(invoice, role, fileType)
      return document ? document.isAvailable : false
    },

    getInvoiceDocument (invoice: InvoiceSummary, role: string, fileType: string): ?InvoiceDocument {
      return invoice.invoiceDocuments.filter(invoiceDocument => {
        return fileType === invoiceDocument.fileType && role === invoiceDocument.role
      })[0] || null
    },

    async downloadInvoiceDocument (invoice: InvoiceSummary, role: string, fileType: string): Promise<void> {
      const document = this.getInvoiceDocument(invoice, role, fileType)
      try {
        await Vue.prototype.$container.b2bClient.downloadInvoiceDocumentFile(invoice, document)
      } catch (error) {
        showAlertErrorHandler.methods.showAlertForErrorAndRedirectToRoute(
          error,
          {401: i18n.t('generic.jwt-expired')},
          {401: {name: 'login'}})
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/invoice-document-group-list-item.js